export const columns = [
  {
    title: "Dirección",
    dataIndex: "address",
    width: 270,
  },
  {
    title: "Tipo",
    dataIndex: "type_address",
    width: 130,
    key: "type_address",
    slots: { customRender: "type_address" },
  },
  {
    title: "Departamento",
    dataIndex: "department",
    width: 130,
    key: "department",
    slots: { customRender: "department" },
  },
  {
    title: "Provincia",
    dataIndex: "province",
    width: 130,
    key: "province",
    slots: { customRender: "province" },
  },
  {
    title: "Distrito",
    dataIndex: "district",
    width: 160,
  },
  {
    title: "Acciones",
    key: "action",
    slots: { customRender: "actionScoped" },
    width: 100,
    fixed: "right",
  },
];
